import { useDispatch } from 'react-redux';
import { resetStore, persistor } from './store';
import { resetUser } from './userSlice';
import { resetNumberManagement } from './numberManagementSlice';
import { resetUsersData } from './userManagementSlice';

// Slice reset actions mapping
const SLICE_RESET_ACTIONS = {
    user: resetUser,
    numberManagement: resetNumberManagement,
    availableUsers: resetUsersData,
};

// Method 1: Complete store reset (clears everything including persisted data)
const useResetAllStore = () => {
    const dispatch = useDispatch();

    const resetAll = async () => {
        // Dispatch the reset action
        dispatch(resetStore());

        // Optional: Also purge the persistor to ensure complete cleanup
        await persistor.purge();

        // Optional: You can also flush to ensure immediate persistence
        await persistor.flush();
    };

    return resetAll;
};

// Method 2: Reset all slices (keeps persistence)
const useResetAllSlices = () => {
    const dispatch = useDispatch();

    const resetSlices = () => {
        Object.values(SLICE_RESET_ACTIONS).forEach((resetAction) => {
            dispatch(resetAction());
        });
    };

    return resetSlices;
};

// Method 3: Reset only specific slices (can be called without hook - keeps persistence)
const resetSpecificSlices = (dispatch, sliceNames = []) => {
    sliceNames.forEach((sliceName) => {
        const resetAction = SLICE_RESET_ACTIONS[sliceName];
        if (resetAction) {
            dispatch(resetAction());
        } else {
            console.warn(`No reset action found for slice: ${sliceName}`);
        }
    });
};

// Method 4: Direct reset function (can be called without hook)
const resetEntireStore = async (dispatch) => {
    await persistor.purge();
    dispatch(resetStore());
    await persistor.flush();
};

export {
    useResetAllStore,
    useResetAllSlices,
    resetSpecificSlices,
    resetEntireStore,
};
